(function () {
  if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") {
    return;
  }
  gsap.registerPlugin(ScrollTrigger);

  const containers = document.querySelectorAll(".cew-parallax-container");

  if (!containers || !containers.length) {
    return;
  }
  containers.forEach(function (container) {
    const image = container.querySelector(".cew-parallax-image");
    if (!image) {
      return;
    }

    const toPx = function (value) {
      if (typeof value === "number") return value;
      if (!value) return 0;
      const v = String(value).trim();
      if (v.endsWith("vh")) {
        const numVh = parseFloat(v);
        return isNaN(numVh) ? 0 : (window.innerHeight * numVh) / 100;
      }
      if (v.endsWith("px")) {
        const numPx = parseFloat(v);
        return isNaN(numPx) ? 0 : numPx;
      }
      const num = parseFloat(v);
      return isNaN(num) ? 0 : num;
    };

    const setup = function () {
      const imgHeight = image.offsetHeight || image.clientHeight || 0;
      if (!imgHeight) {
        setTimeout(setup, 100);
        return;
      }

      let yDistance = 0;
      const hasNoTopOffset = container.classList.contains(
        "cew-parallax-no-top-offset"
      );
      const defaultMin = "50vh";
      const defaultMinNoTop = "25vh";

      let minHeight = "";
      const sectionEl = container.querySelector(".brxe-section");

      if (sectionEl) {
        minSourceStyle = window.getComputedStyle(sectionEl);
        minHeight = minSourceStyle.getPropertyValue("--image-min-height") || "";
      }

      const cleanMin =
        minHeight && minHeight.trim() !== ""
          ? minHeight.trim()
          : hasNoTopOffset
          ? defaultMinNoTop
          : defaultMin;

      let translatePx = toPx(cleanMin);
      if (hasNoTopOffset) {
        translatePx = translatePx / 2;
      }

      image.style.minHeight = "calc(100vh + ".concat(cleanMin, ")");
      yDistance = translatePx;
      const direction = image.getAttribute("data-parallax-direction") || "down";
      if (direction === "up") {
        yDistance = -yDistance;
      }

      const scrollStart = "top top";
      const scrollEnd = hasNoTopOffset
        ? "+=".concat(imgHeight, "px")
        : "bottom bottom";

      const scaleAttr = parseFloat(image.getAttribute("data-parallax-scale"));
      const baseScale = !isNaN(scaleAttr) && scaleAttr > 0 ? scaleAttr : 1.1;
      const scale = hasNoTopOffset ? 1 + (baseScale - 1) / 2 : baseScale;

      const animationType =
        image.getAttribute("data-parallax-animation") || "standard";

      if (animationType === "three_phase") {
        const vh100 = window.innerHeight;
        const totalDistance = hasNoTopOffset
          ? imgHeight
          : container.offsetHeight - vh100;

        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: container,
            start: scrollStart,
            end: scrollEnd,
            scrub: true,
            markers: false,
          },
        });

        tl.to(image, {
          y: yDistance / 2,
          duration: vh100,
          ease: "none",
        });

        tl.to(image, {
          scale: scale,
          duration: Math.max(0, totalDistance - 2 * vh100),
          ease: "none",
        });

        tl.to(image, {
          y: yDistance,
          duration: vh100,
          ease: "none",
        });
      } else {
        // Standard (Direct) animation
        gsap.to(image, {
          y: yDistance,
          scale: scale,
          ease: "none",
          scrollTrigger: {
            trigger: container,
            start: scrollStart,
            end: scrollEnd,
            scrub: true,
            markers: false,
          },
        });
      }
    };

    if (image.complete) {
      setup();
    } else {
      image.addEventListener("load", setup, { once: true });
    }
  });
})();
